import { Component, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Login, Logout } from 'src/app/shared/state/application.actions';
import { ApplicationState } from 'src/app/shared/state/application.state';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.html',
    styleUrls: ['./not-found.scss'],
    standalone: false,
})
export class NotFound {
    private readonly store = inject(Store);

    public isUserLoggedIn$: Observable<boolean> = this.store.select(ApplicationState.isUserLoggedIn);
    public username$: Observable<string> = this.store.select(ApplicationState.currentUserName);

    public login() {
        this.store.dispatch(new Login());
    }

    public logout() {
        this.store.dispatch(new Logout());
    }
}
